import { render, staticRenderFns } from "./photoContestRecord.vue?vue&type=template&id=82641e84&scoped=true"
import script from "./photoContestRecord.vue?vue&type=script&lang=js"
export * from "./photoContestRecord.vue?vue&type=script&lang=js"
import style0 from "./photoContestRecord.vue?vue&type=style&index=0&id=82641e84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82641e84",
  null
  
)

export default component.exports